"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectConnector = void 0;
const Errors_1 = require("../../Errors");
const ethers_1 = require("ethers");
const BaseConnector_1 = require("../BaseConnector");
const Web3BaseAdapter_1 = require("../../Adapters/Web3BaseAdapter");
const ethereum_provider_1 = __importDefault(require("@walletconnect/ethereum-provider"));
const Adapters_1 = require("../../Adapters");
const Types_1 = require("../../Types");
class WalletConnectConnector extends BaseConnector_1.BaseConnector {
    constructor(config, metadata = {
        name: Types_1.WalletConnectors.WalletConnect,
        displayName: "WalletConnect",
        isWallet: true,
    }) {
        super(metadata, config);
    }
    _initAgent() {
        return new ethereum_provider_1.default({
            rpc: {
                [this.config.chainId]: this.config.publicRpc,
            },
            chainId: this.config.chainId,
            qrcode: true,
        });
    }
    async _connect() {
        this.agent = this._initAgent();
        const { accounts } = await this.agent.connector
            .connect({
            chainId: this.config.chainId,
        })
            .catch((err) => {
            this.agent = this._initAgent();
            throw err;
        });
        const address = ethers_1.ethers.utils.getAddress(accounts[0]);
        const provider = new ethers_1.ethers.providers.Web3Provider(this.agent);
        const { chainId } = await provider.getNetwork();
        const chainIdStr = `${chainId}`;
        const adapter = new Web3BaseAdapter_1.Web3BaseAdapter(this.config);
        adapter.setAddress(address);
        adapter.setProvider(provider);
        const multicall = new Adapters_1.Web3MulticallAdapter(adapter);
        const isValidNetwork = await adapter.isValidNetwork(chainIdStr);
        if (!isValidNetwork) {
            throw new Errors_1.InvalidNetworkError(chainIdStr);
        }
        this.initEventController();
        return { adapter, multicall };
    }
    async isAvailable() {
        return true;
    }
    getAgent() {
        return this.agent;
    }
    async initEventController() {
        const agent = this.getAgent();
        this.on("Disconnect", () => {
            agent.disconnect();
        });
    }
}
exports.WalletConnectConnector = WalletConnectConnector;
